<template>
  <div class="hello">
    <!-- <yearAndMonthSelect></yearAndMonthSelect> -->
    <div class="main-con">
      <div class="crumbs">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item>招聘渠道分类统计</el-breadcrumb-item>
          <el-breadcrumb-item>年报</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="annualChannelTable">
        <el-table :data="tableData" :max-height="tableHeight-180" v-loading="listLoading" element-loading-text="报表实时生成中"
              element-loading-spinner="el-icon-loading" style="width: 99%" stripe @cell-click="handdle">
          <el-table-column label=" ">
            <!-- <el-table-column align="center" fixed type="selection" width="40px"></el-table-column> -->
            <el-table-column align="center" label="序号" min-width="5%">
              <template slot-scope="scope">
                <span>{{(listQuery.currpage - 1) * listQuery.perpage + scope.$index + 1}}</span>
              </template>
            </el-table-column>
            <el-table-column align="center" fixed label="服务中心" prop="StrSrvCent" min-width="8%"></el-table-column>
            <el-table-column align="center" label="总计" min-width="8%">
              <template slot-scope="{row}">
                <div>{{row.Allempuser?row.Allempuser:0}}</div>
              </template>
            </el-table-column>
            <el-table-column align="center" label="市内总计" min-width="8%">
              <template slot-scope="{row}">
                <div>{{row.Incityempuser?row.Incityempuser:0}}</div>
              </template>
            </el-table-column>
            <el-table-column align="center" label="市外总计" min-width="8%">
              <template slot-scope="{row}">
                <div>{{row.Outcityempuser?row.Outcityempuser:0}}</div>
              </template>
            </el-table-column>
            <el-table-column align="center" label="其他总计" min-width="8%">
              <template slot-scope="{row}">
                <div>{{row.Otherempuser?row.Otherempuser:0}}</div>
              </template>
            </el-table-column>
          </el-table-column>
          <el-table-column label="1月" v-if="showMonth==0" :key="Math.random()">
            <template slot="header">
              <div class="monthDirection">
                <el-button disabled>
                  <img src="../../assets/employee/images/left.png" alt="" style="width:31px;height:31px">
                </el-button>
                <div class="month">1月</div>
                <div style="width:31px"></div>
              </div>
            </template>
            <el-table-column align="center" label="市内" prop="1" min-width="10%">
              <template slot-scope="{row}">
                <div class="green">{{row.data[0].Incityempuser}}</div>
                <div class="rate">{{row.data[0].IncityempuserRate&&row.data[0].IncityempuserRate!='NaN'?(row.data[0].IncityempuserRate*100).toFixed(2)+'%':'0.00%'}}</div>
              </template>
            </el-table-column>
            <el-table-column align="center" label="市外" prop="1" min-width="10%">
              <template slot-scope="{row}">
                <div class="orange">{{row.data[0].Outcityempuser}}</div>
                <div class="rate">{{row.data[0].OutcityempuserRate&&row.data[0].OutcityempuserRate!='NaN'?(row.data[0].OutcityempuserRate*100).toFixed(2)+'%':'0.00%'}}</div>
              </template>
            </el-table-column>
            <el-table-column align="center" label="其他情况" prop="1" min-width="10%">
              <template slot-scope="{row}">
                <div class="pink">{{row.data[0].Otherempuser}}</div>
                <div class="rate">{{row.data[0].OtherempuserRate&&row.data[0].OtherempuserRate!='NaN'?(row.data[0].OtherempuserRate*100).toFixed(2)+'%':'0.00%'}}</div>
              </template>
            </el-table-column>
          </el-table-column>
          <el-table-column align="center" label="2月" v-if="showMonth==0" :key="Math.random()">
            <el-table-column align="center" label="市内" prop="2" min-width="10%">
              <template slot-scope="{row}">
                <div class="green">{{row.data[1].Incityempuser}}</div>
                <div class="rate">{{row.data[1].IncityempuserRate&&row.data[1].IncityempuserRate!='NaN'?(row.data[1].IncityempuserRate*100).toFixed(2)+'%':'0.00%'}}</div>
              </template>
            </el-table-column>
            <el-table-column align="center" label="市外" prop="2" min-width="10%">
              <template slot-scope="{row}">
                <div class="orange">{{row.data[1].Outcityempuser}}</div>
                <div class="rate">{{row.data[1].OutcityempuserRate&&row.data[1].OutcityempuserRate!='NaN'?(row.data[1].OutcityempuserRate*100).toFixed(2)+'%':'0.00%'}}</div>
              </template>
            </el-table-column>
            <el-table-column align="center" label="其他情况" prop="2" min-width="10%">
              <template slot-scope="{row}">
                <div class="pink">{{row.data[1].Otherempuser}}</div>
                <div class="rate">{{row.data[1].OtherempuserRate&&row.data[1].OtherempuserRate!='NaN'?(row.data[1].OtherempuserRate*100).toFixed(2)+'%':'0.00%'}}</div>
              </template>
            </el-table-column>
          </el-table-column>
          <el-table-column align="center" label="3月" v-if="showMonth==0" :key="Math.random()">
            <template slot="header">
              <div class="monthDirection">
                <div style="width:31px"></div>
                <div class="month">3月</div>
                <el-button @click="goMonth2">
                  <img src="../../assets/employee/images/right.png" alt="" style="width:31px;height:31px">
                </el-button>
              </div>
            </template>
            <el-table-column align="center" label="市内" prop="3" min-width="10%">
              <template slot-scope="{row}">
                <div class="green">{{row.data[2].Incityempuser}}</div>
                <div class="rate">{{row.data[2].IncityempuserRate&&row.data[2].IncityempuserRate!='NaN'?(row.data[2].IncityempuserRate*100).toFixed(2)+'%':'0.00%'}}</div>
              </template>
            </el-table-column>
            <el-table-column align="center" label="市外" prop="3" min-width="10%">
              <template slot-scope="{row}">
                <div class="orange">{{row.data[2].Outcityempuser}}</div>
                <div class="rate">{{row.data[2].OutcityempuserRate&&row.data[2].OutcityempuserRate!='NaN'?(row.data[2].OutcityempuserRate*100).toFixed(2)+'%':'0.00%'}}</div>
              </template>
            </el-table-column>
            <el-table-column align="center" label="其他情况" prop="3" min-width="10%">
              <template slot-scope="{row}">
                <div class="pink">{{row.data[2].Otherempuser}}</div>
                <div class="rate">{{row.data[2].OtherempuserRate&&row.data[2].OtherempuserRate!='NaN'?(row.data[2].OtherempuserRate*100).toFixed(2)+'%':'0.00%'}}</div>
              </template>
            </el-table-column>
          </el-table-column>

          <el-table-column align="center" label="4月" v-if="showMonth==1" :key="Math.random()">
            <template slot="header">
              <div class="monthDirection">
                <el-button @click="goMonth1">
                  <img src="../../assets/employee/images/left.png" alt="" style="width:31px;height:31px">
                </el-button>
                <div class="month">4月</div>
                <div style="width:31px"></div>
              </div>
            </template>
            <el-table-column align="center" label="市内" prop="4" min-width="10%">
              <template slot-scope="{row}">
                <div class="green">{{row.data[3].Incityempuser}}</div>
                <div class="rate">{{row.data[3].IncityempuserRate&&row.data[3].IncityempuserRate!='NaN'?(row.data[3].IncityempuserRate*100).toFixed(2)+'%':'0.00%'}}</div>
              </template>
            </el-table-column>
            <el-table-column align="center" label="市外" prop="4" min-width="10%">
              <template slot-scope="{row}">
                <div class="orange">{{row.data[3].Outcityempuser}}</div>
                <div class="rate">{{row.data[3].OutcityempuserRate&&row.data[3].OutcityempuserRate!='NaN'?(row.data[3].OutcityempuserRate*100).toFixed(2)+'%':'0.00%'}}</div>
              </template>
            </el-table-column>
            <el-table-column align="center" label="其他情况" prop="4" min-width="10%">
              <template slot-scope="{row}">
                <div class="pink">{{row.data[3].Otherempuser}}</div>
                <div class="rate">{{row.data[3].OtherempuserRate&&row.data[3].OtherempuserRate!='NaN'?(row.data[3].OtherempuserRate*100).toFixed(2)+'%':'0.00%'}}</div>
              </template>
            </el-table-column>
          </el-table-column>
          <el-table-column align="center" label="5月" v-if="showMonth==1" :key="Math.random()">
            <el-table-column prop="5" align="center" label="市内" min-width="10%">
              <template slot-scope="{row}">
                <div class="green">{{row.data[4].Incityempuser}}</div>
                <div class="rate">{{row.data[4].IncityempuserRate&&row.data[4].IncityempuserRate!='NaN'?(row.data[4].IncityempuserRate*100).toFixed(2)+'%':'0.00%'}}</div>
              </template>
            </el-table-column>
            <el-table-column align="center" label="市外" prop="5" min-width="10%">
              <template slot-scope="{row}">
                <div class="orange">{{row.data[4].Outcityempuser}}</div>
                <div class="rate">{{row.data[4].OutcityempuserRate&&row.data[4].OutcityempuserRate!='NaN'?(row.data[4].OutcityempuserRate*100).toFixed(2)+'%':'0.00%'}}</div>
              </template>
            </el-table-column>
            <el-table-column align="center" label="其他情况" prop="5" min-width="10%">
              <template slot-scope="{row}">
                <div class="pink">{{row.data[4].Otherempuser}}</div>
                <div class="rate">{{row.data[4].OtherempuserRate&&row.data[4].OtherempuserRate!='NaN'?(row.data[4].OtherempuserRate*100).toFixed(2)+'%':'0.00%'}}</div>
              </template>
            </el-table-column>
          </el-table-column>
          <el-table-column align="center" label="6月" v-if="showMonth==1" :key="Math.random()">
            <template slot="header">
              <div class="monthDirection">
                <div style="width:31px"></div>
                <div class="month">6月</div>
                <el-button @click="goMonth3">
                  <img src="../../assets/employee/images/right.png" alt="" style="width:31px;height:31px">
                </el-button>
              </div>
            </template>
            <el-table-column align="center" label="市内" prop="6" min-width="10%">
              <template slot-scope="{row}">
                <div class="green">{{row.data[5].Incityempuser}}</div>
                <div class="rate">{{row.data[5].IncityempuserRate&&row.data[5].IncityempuserRate!='NaN'?(row.data[5].IncityempuserRate*100).toFixed(2)+'%':'0.00%'}}</div>
              </template>
            </el-table-column>
            <el-table-column align="center" label="市外" prop="6" min-width="10%">
              <template slot-scope="{row}">
                <div class="orange">{{row.data[5].Outcityempuser}}</div>
                <div class="rate">{{row.data[5].OutcityempuserRate&&row.data[5].OutcityempuserRate!='NaN'?(row.data[5].OutcityempuserRate*100).toFixed(2)+'%':'0.00%'}}</div>
              </template>
            </el-table-column>
            <el-table-column align="center" prop="6" label="其他情况" min-width="10%">
              <template slot-scope="{row}">
                <div class="pink">{{row.data[5].Otherempuser}}</div>
                <div class="rate">{{row.data[5].OtherempuserRate&&row.data[5].OtherempuserRate!='NaN'?(row.data[5].OtherempuserRate*100).toFixed(2)+'%':'0.00%'}}</div>
              </template>
            </el-table-column>
          </el-table-column>

          <el-table-column align="center" label="7月" v-if="showMonth==2" :key="Math.random()">
            <template slot="header">
              <div class="monthDirection">
                <el-button @click="goMonth2">
                  <img src="../../assets/employee/images/left.png" alt="" style="width:31px;height:31px">
                </el-button>
                <div class="month">7月</div>
                <div style="width:31px"></div>
              </div>
            </template>
            <el-table-column align="center" label="市内" prop="7" min-width="10%">
              <template slot-scope="{row}">
                <div class="green">{{row.data[6].Incityempuser}}</div>
                <div class="rate">{{row.data[6].IncityempuserRate&&row.data[6].IncityempuserRate!='NaN'?(row.data[6].IncityempuserRate*100).toFixed(2)+'%':'0.00%'}}</div>
              </template>
            </el-table-column>
            <el-table-column align="center" label="市外" prop="7" min-width="10%">
              <template slot-scope="{row}">
                <div class="orange">{{row.data[6].Outcityempuser}}</div>
                <div class="rate">{{row.data[6].OutcityempuserRate&&row.data[6].OutcityempuserRate!='NaN'?(row.data[6].OutcityempuserRate*100).toFixed(2)+'%':'0.00%'}}</div>
              </template>
            </el-table-column>
            <el-table-column align="center" prop="7" label="其他情况" min-width="10%">
              <template slot-scope="{row}">
                <div class="pink">{{row.data[6].Otherempuser}}</div>
                <div class="rate">{{row.data[6].OtherempuserRate&&row.data[6].OtherempuserRate!='NaN'?(row.data[6].OtherempuserRate*100).toFixed(2)+'%':'0.00%'}}</div>
              </template>
            </el-table-column>
          </el-table-column>
          <el-table-column align="center" label="8月" v-if="showMonth==2" :key="Math.random()">
            <el-table-column align="center" label="市内" prop="8" min-width="10%">
              <template slot-scope="{row}">
                <div class="green">{{row.data[7].Incityempuser}}</div>
                <div class="rate">{{row.data[7].IncityempuserRate&&row.data[7].IncityempuserRate!='NaN'?(row.data[7].IncityempuserRate*100).toFixed(2)+'%':'0.00%'}}</div>
              </template>
            </el-table-column>
            <el-table-column align="center" label="市外" prop="8" min-width="10%">
              <template slot-scope="{row}">
                <div class="orange">{{row.data[7].Outcityempuser}}</div>
                <div class="rate">{{row.data[7].OutcityempuserRate&&row.data[7].OutcityempuserRate!='NaN'?(row.data[7].OutcityempuserRate*100).toFixed(2)+'%':'0.00%'}}</div>
              </template>
            </el-table-column>
            <el-table-column align="center" label="其他情况" prop="8" min-width="10%">
              <template slot-scope="{row}">
                <div class="pink">{{row.data[7].Otherempuser}}</div>
                <div class="rate">{{row.data[7].OtherempuserRate&&row.data[7].OtherempuserRate!='NaN'?(row.data[7].OtherempuserRate*100).toFixed(2)+'%':'0.00%'}}</div>
              </template>
            </el-table-column>
          </el-table-column>
          <el-table-column align="center" label="9月" v-if="showMonth==2" :key="Math.random()">
            <template slot="header">
              <div class="monthDirection">
                <div style="width:31px"></div>
                <div class="month">9月</div>
                <el-button @click="goMonth4">
                  <img src="../../assets/employee/images/right.png" alt="" style="width:31px;height:31px">
                </el-button>
              </div>
            </template>
            <el-table-column align="center" prop="9" label="市内" min-width="10%">
              <template slot-scope="{row}">
                <div class="green">{{row.data[8].Incityempuser}}</div>
                <div class="rate">{{row.data[8].IncityempuserRate&&row.data[8].IncityempuserRate!='NaN'?(row.data[8].IncityempuserRate*100).toFixed(2)+'%':'0.00%'}}</div>
              </template>
            </el-table-column>
            <el-table-column align="center" prop="9" label="市外" min-width="10%">
              <template slot-scope="{row}">
                <div class="orange">{{row.data[8].Outcityempuser}}</div>
                <div class="rate">{{row.data[8].OutcityempuserRate&&row.data[8].OutcityempuserRate!='NaN'?(row.data[8].OutcityempuserRate*100).toFixed(2)+'%':'0.00%'}}</div>
              </template>
            </el-table-column>
            <el-table-column align="center" prop="9" label="其他情况" min-width="10%">
              <template slot-scope="{row}">
                <div class="pink">{{row.data[8].Otherempuser}}</div>
                <div class="rate">{{row.data[8].OtherempuserRate&&row.data[8].OtherempuserRate!='NaN'?(row.data[8].OtherempuserRate*100).toFixed(2)+'%':'0.00%'}}</div>
              </template>
            </el-table-column>
          </el-table-column>

          <el-table-column align="center" label="10月" v-if="showMonth==3" :key="Math.random()">
            <template slot="header">
              <div class="monthDirection">
                <el-button @click="goMonth3">
                  <img src="../../assets/employee/images/left.png" alt="" style="width:31px;height:31px">
                </el-button>
                <div class="month">10月</div>
                <div style="width:31px"></div>
              </div>
            </template>
            <el-table-column align="center" prop="10" label="市内" min-width="10%">
              <template slot-scope="{row}">
                <div class="green">{{row.data[9].Incityempuser}}</div>
                <div class="rate">{{row.data[9].IncityempuserRate&&row.data[9].IncityempuserRate!='NaN'?(row.data[9].IncityempuserRate*100).toFixed(2)+'%':'0.00%'}}</div>
              </template>
            </el-table-column>
            <el-table-column align="center" prop="10" label="市外" min-width="10%">
              <template slot-scope="{row}">
                <div class="orange">{{row.data[9].Outcityempuser}}</div>
                <div class="rate">{{row.data[9].OutcityempuserRate&&row.data[9].OutcityempuserRate!='NaN'?(row.data[9].OutcityempuserRate*100).toFixed(2)+'%':'0.00%'}}</div>
              </template>
            </el-table-column>
            <el-table-column align="center" prop="10" label="其他情况" min-width="10%">
              <template slot-scope="{row}">
                <div class="pink">{{row.data[9].Otherempuser}}</div>
                <div class="rate">{{row.data[9].OtherempuserRate&&row.data[9].OtherempuserRate!='NaN'?(row.data[9].OtherempuserRate*100).toFixed(2)+'%':'0.00%'}}</div>
              </template>
            </el-table-column>
          </el-table-column>
          <el-table-column align="center" label="11月" v-if="showMonth==3" :key="Math.random()">
            <el-table-column align="center" label="市内" prop="11" min-width="10%">
              <template slot-scope="{row}">
                <div class="green">{{row.data[10].Incityempuser}}</div>
                <div class="rate">{{row.data[10].IncityempuserRate&&row.data[10].IncityempuserRate!='NaN'?(row.data[10].IncityempuserRate*100).toFixed(2)+'%':'0.00%'}}</div>
              </template>
            </el-table-column>
            <el-table-column align="center" label="市外" prop="11" min-width="10%">
              <template slot-scope="{row}">
                <div class="orange">{{row.data[10].Outcityempuser}}</div>
                <div class="rate">{{row.data[10].OutcityempuserRate&&row.data[10].OutcityempuserRate!='NaN'?(row.data[10].OutcityempuserRate*100).toFixed(2)+'%':'0.00%'}}</div>
              </template>
            </el-table-column>
            <el-table-column align="center" label="其他情况" prop="11" min-width="10%">
              <template slot-scope="{row}">
                <div class="pink">{{row.data[10].Otherempuser}}</div>
                <div class="rate">{{row.data[10].OtherempuserRate&&row.data[10].OtherempuserRate!='NaN'?(row.data[10].OtherempuserRate*100).toFixed(2)+'%':'0.00%'}}</div>
              </template>
            </el-table-column>
          </el-table-column>
          <el-table-column align="center" label="12月" v-if="showMonth==3" :key="Math.random()">
            <template slot="header">
              <div class="monthDirection">
                <div style="width:31px"></div>
                <div class="month">12月</div>
                <el-button disabled>
                  <img src="../../assets/employee/images/right.png" alt="" style="width:31px;height:31px">
                </el-button>
              </div>
            </template>
            <el-table-column align="center" label="市内" prop="12" min-width="10%">
              <template slot-scope="{row}">
                <div class="green">{{row.data[11].Incityempuser}}</div>
                <div class="rate">{{row.data[11].IncityempuserRate&&row.data[11].IncityempuserRate!='NaN'?(row.data[11].IncityempuserRate*100).toFixed(2)+'%':'0.00%'}}</div>
              </template>
            </el-table-column>
            <el-table-column align="center" label="市外" prop="12" min-width="10%">
              <template slot-scope="{row}">
                <div class="orange">{{row.data[11].Outcityempuser}}</div>
                <div class="rate">{{row.data[11].OutcityempuserRate&&row.data[11].OutcityempuserRate!='NaN'?(row.data[11].OutcityempuserRate*100).toFixed(2)+'%':'0.00%'}}</div>
              </template>
            </el-table-column>
            <el-table-column align="center" label="其他情况" prop="12" min-width="10%">
              <template slot-scope="{row}">
                <div class="pink">{{row.data[11].Otherempuser}}</div>
                <div class="rate">{{row.data[11].OtherempuserRate&&row.data[11].OtherempuserRate!='NaN'?(row.data[11].OtherempuserRate*100).toFixed(2)+'%':'0.00%'}}</div>
              </template>
            </el-table-column>
          </el-table-column>
        </el-table>
        <div class="block" v-if="totalcount>0">
          <!-- @size-change="handleSizeChange" -->
          <el-pagination @current-change="handleCurrentChange" :current-page.sync="currentPage" :page-size="10000" layout="total,prev, pager, next, jumper" :total="totalcount"></el-pagination>
        </div>
      </div>
    </div>
    <el-drawer :visible.sync="drawer1" :with-header="false" :modal="false" size="78%">
      <div class="titleAndButton">
        <div class="monthlyTitle">
          招聘渠道分类统计 | {{strsrvcent1}} | {{toChildrenData.startdate+'~'+toChildrenData.enddate}}
        </div>
        <div>
          <el-input size="small" v-model="serDtlQuery.strobjname" placeholder="请输入项目名称" @keyup.enter.native="onSearch" style="width:200px;margin-right:10px"></el-input>
          <el-button class="exportButton" style="margin-right:10px" :loading="btnLoading1" @click="exportHandle1">导出</el-button>
          <button class="clear" @click="drawer1=false" style="margin-right:5px">关闭</button>
        </div>
      </div>
      <div>
        <div class="monthlyChannelTable">
        <el-table :data="tableData3" v-loading="drawer1Loading" style="width: 99%" stripe  @cell-click="handdle3">
          <!-- <el-table-column align="center" type="selection" min-width="1%"></el-table-column> -->
          <el-table-column align="center" label="序号" width="100px">
            <template slot-scope="{$index}">
              <span>{{Number($index)+1}}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="项目名称" prop="StrObjName"></el-table-column>
          <el-table-column align="center" label="市内">
            <template slot-scope="scope">
               <div class="green">{{scope.row.Incityempuser}}</div>
               <div class="rate">{{(scope.row.IncityempuserRate*100).toFixed(2)+'%'}}</div>
            </template>
          </el-table-column>
          <el-table-column align="center" label="市外" prop="outsideCity">
            <template slot-scope="scope">
              <div class="green">{{scope.row.Outcityempuser}}</div>
              <div class="rate">{{(scope.row.OutcityempuserRate*100).toFixed(2)+'%'}}</div>
            </template>
          </el-table-column>
          <el-table-column align="center" label="其他" prop="otherChannel">
            <template slot-scope="scope">
              <div class="green">{{scope.row.Otherempuser}}</div>
              <div class="rate">{{(scope.row.OtherempuserRate*100).toFixed(2)+'%'}}</div>
            </template>
          </el-table-column>
          <el-table-column align="center" label="合计" prop="total">
            <template slot-scope="scope">
              <div>{{scope.row.Allempuser}}</div>
              <div>{{(scope.row.AllempuserRate*100).toFixed(2)+'%'}}</div>
            </template>
          </el-table-column>
        </el-table>
        <div class="block" v-if="totalcount3>0">
          <el-pagination
            @current-change="handleCurrentChange3"
            :current-page.sync="serDtlQuery.currpage"
            :page-size="10"
            layout="total,prev, pager, next, jumper"
            :total="totalcount3"
          ></el-pagination>
        </div>
      </div>
      </div>
    </el-drawer>

    <el-drawer :visible.sync="drawer2" :with-header="false" :modal="false" size="77%">
      <div class="titleAndButton">
        <div class="monthlyTitle">
          {{strsrvcent1}} | {{cityTxt}}招聘名单 {{isServiceAct==false?nowDateVal:(toChildrenData.startdate+'~'+toChildrenData.enddate)}}
        </div>
        <div>
          <el-input size="small" v-model="cityDtlQuery.strobjname" placeholder="请输入项目名称" @keyup.enter.native="onSearch2" style="width:200px;margin-right:10px"></el-input>
          <el-button class="exportButton" style="margin-right:10px" :loading="btnLoading2" @click="exportHandle2">导出</el-button>
          <button class="clear" @click="drawer2=false" style="margin-right:5px">关闭</button>
        </div>
      </div>
      <div>
        <div class="monthlyReportTable">
          <el-table :data="tableData5" v-loading="drawer2Loading" style="width: 99%" stripe @cell-click="handdle2">
            <!-- <el-table-column align="center" type="selection" min-width="1%"></el-table-column> -->
            <el-table-column align="center" label="序号" width="100px">
              <template slot-scope="{$index}">
                <span>{{Number($index)+1}}</span>
              </template>
            </el-table-column>
          <el-table-column align="center" label="项目名称" prop="StrObjName"></el-table-column>
          <el-table-column align="center" label="劳动合同签署公司全称" prop="StrBlCmp"></el-table-column>
          <el-table-column align="center" label="员工姓名" prop="StrEmpName"></el-table-column>
          <el-table-column align="center" label="身份证号码" prop="StrIdCard"></el-table-column>
          <el-table-column align="center" label="用工之日">
            <template slot-scope="scope">
              <span>{{isNull(scope.row.DtEntryBdate)?'':scope.row.DtEntryBdate.replace('T',' ').substring(0,11)}}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="在/离职状态" prop="StrWorkState"></el-table-column>
          <el-table-column align="center" label="离职日期">
            <template slot-scope="scope">
              <span>{{isNull(scope.row.DtDepartureDate)?'':scope.row.DtDepartureDate.replace('T',' ').substring(0,11)}}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="实际离职日期">
            <template slot-scope="scope">
              <span>{{isNull(scope.row.DtRealDepartureDate)?'':scope.row.DtRealDepartureDate.replace('T',' ').substring(0,11)}}</span>
            </template>
          </el-table-column>
          
            <el-table-column align="center" label="招聘渠道">
              <template slot-scope="scope">
                <span v-if="scope.row.StrInCity">{{scope.row.StrInCity}}</span>
                <span v-if="scope.row.StrOutsideCity">{{scope.row.StrInCity ? '/' +  scope.row.StrOutsideCity : scope.row.StrOutsideCity}}</span>
                <span v-if="scope.row.StrOther">{{(scope.row.StrInCity|| scope.row.StrOutsideCity) ? '/' + scope.row.StrOther :scope.row.StrOther}}</span>
                <!-- <span v-if="scope.row.StrInCity=='XXX'">{{'市外'+'/'+scope.row.StrOther+'/'+scope.row.StrOutsideCity}}</span>
              <span v-if="scope.row.StrInCity==''">{{'其他'+'/'+scope.row.StrOther+'/'+scope.row.StrOutsideCity}}</span> -->
            </template>
          </el-table-column>
          </el-table>
          <div class="block" v-if="totalcount5>0">
            <el-pagination
              @current-change="handleCurrentChange2"
              :current-page.sync="cityDtlQuery.currpage"
              :page-size="10"
              layout="total,prev, pager, next, jumper"
              :total="totalcount5"
            ></el-pagination>
          </div>
        </div>
      </div>
    </el-drawer>

    <el-drawer :visible.sync="drawer4" :with-header="false" :modal="false" size="77%">
      <div class="titleAndButton">
        <div class="monthlyTitle">
          招聘渠道分类统计 | {{strsrvcent1}} | {{toChildrenData.startdate+'~'+toChildrenData.enddate}} | {{strobjname2}} | 分渠道招聘名单
        </div>
        <div>
          <el-button class="exportButton" style="margin-right:10px" :loading="btnLoading4" @click="exportHandle4">导出</el-button>
          <button class="clear" @click="drawer4=false" style="margin-right:5px">关闭</button>
        </div>
      </div>
      <div>
        <div class="monthlyReportTable">
        <el-table :data="tableData7" style="width: 99%" stripe v-loading="drawer3Loading">
          <!-- <el-table-column align="center" type="selection" min-width="1%"></el-table-column> -->
          <el-table-column align="center" label="序号" width="100px">
            <template slot-scope="{$index}">
              <span>{{Number($index)+1}}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="员工姓名" prop="StrEmpName"></el-table-column>
          <el-table-column align="center" label="身份证号码" prop="StrIdCard"></el-table-column>
          <el-table-column align="center" label="用工之日">
            <template slot-scope="scope">
              <span>{{isNull(scope.row.DtContractBtime)?'':scope.row.DtContractBtime.replace('T',' ').substring(0,11)}}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="离职日期">
             <template slot-scope="scope">
              <span>{{isNull(scope.row.DtDepartureDate)?'':scope.row.DtDepartureDate.replace('T',' ').substring(0,11)}}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="市内">
            <template slot-scope="scope">
              <span>{{scope.row.StrOther+'/'+scope.row.StrOutsideCity}}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="市外">
            <template slot-scope="scope">
              <span>{{scope.row.StrOther+'/'+scope.row.StrOutsideCity}}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="其他" prop="otherChannel">
            <template slot-scope="scope">
              <span>{{scope.row.StrOther+'/'+scope.row.StrOutsideCity}}</span>
            </template>
          </el-table-column>
        </el-table>
        <div class="block" v-if="totalcount7">
          <el-pagination
            @current-change="handleCurrentChange7"
            :current-page.sync="cityDtlQuery.currpage"
            :page-size="10"
            layout="total,prev, pager, next, jumper"
            :total="totalcount7"
          ></el-pagination>
        </div>
      </div>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import xz from "../../common";
import { parseTime } from '../../utils' //格式化时间格式
// import yearAndMonthSelect from "../../employee/assembly/yearAndMonthSelect";
export default {
  props: {
    toChildrenData: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  components: {
    parseTime
  },
  data() {
    return {
      tableHeight: 0,
      listLoading: false,
      drawer1Loading: false,
      drawer2Loading: false,
      drawer3Loading: false,
      showMonth: 0,
      drawer1: false,
      drawer2: false,
      drawer3: false,
      drawer4: false,
      btnLoading1: false,
      btnLoading2: false,
      btnLoading3: false,
      btnLoading4: false,
      currentPage: 1,
      currentPage2: 1,
      currentPage3: 1,
      currentPage5: 1,
      currentPage6: 1,
      currentPage7: 1,
      totalcount: 0,
      totalcount3: 0,
      totalcount5: 0,
      totalcount6: 0,
      totalcount7: 0,
      strsrvcent1: '',
      //项目名称
      strobjname2: '',
      strdate2: '',
      listQuery: {
        perpage: 10000,
        currpage: 1,
        strdatetype: "month",
        strdate: "",
        strsrvcent: ""
      },
      serDtlQuery: {
        perpage: 10,
        currpage: 1,
        strobjname: ""
      },
      //市内市外参数
      cityDtlQuery: {
        perpage: 10,
        currpage: 1,
        strtype: "all",  //all  市内 市外 其他
        strobjname: ""
      },
      nowDateVal: '',
      strsrvcent2: '',
      cityTxt: '',
      tableData: [],
      tableData3: [],
      tableData5: [],
      tableData6: [],
      tableData7: [],
      dataQuery: [],
      strdatetype2: 'year',
      //是否从服务中心点的
      isServiceAct: true
    }
  },
  async created() {
    this.calHeight();
    //父组件传的值
    this.dataQuery = this.toChildrenData
    this.dataQuery.dateVal = this.toChildrenData.dateVal
    console.log('oo', this.listQuery.dateVal)
    this.getTimeSet()
    this.getList(this.dataQuery)
  },
  methods: {
    calHeight() {
      this.tableHeight = Number(document.body.clientHeight);
      console.log('height', this.tableHeight)
    },
    handleClick(row) {
      console.log(row);
    },
    //判断是否为空(包含0)
    isNull(o) {
      return o == undefined || o == "undefined" || (o + '').indexOf("undefined") > -1 || o == null || o == '' || o == 'null' || o == [] || o == 0 || o == 'NaN' || o == '1900/01/01' || o == '1900-01-01T00:00:00' || o == '1900-01-01';
    },
    // handleSizeChange(val) {
    //   this.page = val
    //   console.log(`每页 ${val} 条`);
    // },
    handleCurrentChange(val) {
      this.dataQuery.currpage = val
      this.listQuery.currpage = val
      this.getList(this.dataQuery)
      console.log(`当前页: ${val}`);
    },
    handleCurrentChange2(val) {
      this.cityDtlQuery.currpage = val
      this.getCityList()
      // console.log(`当前页: ${val}`);
    },
    handleCurrentChange3(val) {
      this.serDtlQuery.currpage = val
      this.getDtlList()
      // console.log(`当前页: ${val}`);
    },
    handleCurrentChange6(val) {
      this.serDtlQuery.currpage = val
      this.getDtlItemList()
    },
    handleCurrentChange7(val) {
      this.cityDtlQuery.currpage = val
      this.getCityList()
    },
    goMonth1() {
      this.showMonth = 0
    },
    goMonth2() {
      this.showMonth = 1
    },
    goMonth3() {
      this.showMonth = 2
    },
    goMonth4() {
      this.showMonth = 3
    },
    //子组件传给父组件的值
    sendMsg() {
      //func: 是父组件指定的传数据绑定的函数，tableData:子组件给父组件传递的数据
      this.$emit('func', this.tableData)
    },
    //导出1
    exportHandle1() {
      this.btnLoading1 = true;
      this.serDtlQuery.perpage = 100000
      this.serDtlQuery.currpage = 1
      this.strdatetype2 = 'year'
      //reporttype ：员工统计 员工统计详情  渠道统计  渠道统计详情  渠道统计雇员
      xz.reportCurrDataTable('渠道统计详情', this.strsrvcent1, this.toChildrenData.strdatetype, this.toChildrenData.strdate, this.serDtlQuery).then(res => {
        console.log("reportCurrDataTable", res);
        if (res.status == 'ok') {
          this.btnLoading1 = false;
          this.$router.push({
            path: '/employee-exportRecordList',
            query: {
              custname: res.msg,
              isReport: true
            }
          })
        } else {
          this.btnLoading1 = false;
          this.$message({
            message: "导出错误",
            type: "error"
          })
        }
      });
    },
    //导出2
    exportHandle2() {
      this.btnLoading2 = true;
      this.cityDtlQuery.perpage = 100000
      this.cityDtlQuery.currpage = 1
      if (this.isServiceAct == true) {
        this.strdatetype2 = 'year'
        this.strdate2 = this.toChildrenData.strdate
      } else {
        this.strdatetype2 = 'month'
        this.strdate2 = this.nowDateVal
      }
      //reporttype ：员工统计 员工统计详情  渠道统计  渠道统计详情  渠道统计雇员
      xz.reportCurrDataTable('渠道统计雇员', this.strsrvcent2, this.strdatetype2, this.strdate2, this.cityDtlQuery).then(res => {
        console.log("reportCurrDataTable", res);
        if (res.status == 'ok') {
          this.btnLoading2 = false;
          this.$router.push({
            path: '/employee-exportRecordList',
            query: {
              custname: res.msg,
              isReport: true
            }
          })
        } else {
          this.btnLoading2 = false;
          this.$message({
            message: "导出错误",
            type: "error"
          })
        }
      });
    },
    //导出4
    exportHandle4() {
      this.btnLoading4 = true;
      this.cityDtlQuery.perpage = 100000
      this.cityDtlQuery.currpage = 1
      if (this.isServiceAct == true) {
        this.strdatetype2 = 'year'
        this.strdate2 = this.toChildrenData.strdate
      } else {
        this.strdatetype2 = 'month'
        this.strdate2 = this.nowDateVal
      }
      //reporttype ：员工统计 员工统计详情  渠道统计  渠道统计详情  渠道统计雇员
      console.log("exportQuery", this.toChildrenData.strdatetype, this.toChildrenData.strdate, this.cityDtlQuery);
      xz.reportCurrDataTable('渠道统计雇员', this.strsrvcent2, this.strdatetype2, this.strdate2, this.cityDtlQuery).then(res => {
        console.log("reportCurrDataTable", res);
        if (res.status == 'ok') {
          this.btnLoading4 = false;
          this.$router.push({
            path: '/employee-exportRecordList',
            query: {
              custname: res.msg,
              isReport: true
            }
          })
        } else {
          this.btnLoading4 = false;
          this.$message({
            message: "导出错误",
            type: "error"
          })
        }
      });
    },
    //表格
    async getList(query) {
      this.listLoading = true
      this.tableData = []
      // console.log('getOpeRecord', query)
      xz.getUserCity(query).then(res => {
        // console.log('getOpeRecord', res)
        if (res.msg && res.msg.length > 0) {
          this.totalcount = parseInt(res.totalcount);
          this.tableData = res.msg
           this.listLoading = false
        } else if(res=='404'){
          this.getList(query)
        }else {
          this.totalcount = 0
          this.tableData = []
           this.listLoading = false
        }
        this.sendMsg()
      })
    },
    //点击服务中心详情
    getDtlList() {
      this.tableData3 = []
      this.drawer1Loading = true
      // console.log('getUserBaseCitydetail', this.toChildrenData.strsrvcent, this.toChildrenData.strdatetype, this.toChildrenData.strdate)
      xz.getUserBaseCitydetail(this.strsrvcent1, this.dataQuery.strdatetype, this.dataQuery.strdate, this.serDtlQuery).then(res => {
        // console.log('getUserBaseCitydetail', res)
        if (res.msg && res.msg.length > 0) {
          this.totalcount3 = parseInt(res.totalcount);
          this.tableData3 = res.msg
        } else {
          this.totalcount3 = 0
          this.tableData3 = []
        }
        this.drawer1Loading = false
      })
    },
    //点击市内市外详情
    getCityList() {
      if (this.drawer4 == true) {
        this.tableData7 = []
        this.drawer3Loading = true
      } else {
        this.tableData5 = []
        this.drawer2Loading = true
      }
      if (this.isServiceAct == true) {
        //是点击一年的市内市外
        this.strdate2 = this.dataQuery.strdate
      } else {
        //单月
        this.strdate2 = this.nowDateVal
      }
      console.log('aa', this.strsrvcent2, this.strdate2, this.cityDtlQuery)
      xz.getBaseUserInCityList(this.strsrvcent2, this.strdate2, this.cityDtlQuery).then(res => {
        console.log('getCityList', res)
        if (res.msg.data && res.msg.data.length > 0) {
          if (this.drawer4 == true) {
            this.totalcount7 = parseInt(res.msg.totalcount);
            this.tableData7 = res.msg.data
            this.drawer3Loading = false
          } else {
            this.totalcount5 = parseInt(res.msg.totalcount);
            this.tableData5 = res.msg.data
            this.drawer2Loading = false
          }
        } else {
          if (this.drawer4 == true) {
            this.totalcount7 = 0
            this.tableData7 = []
            this.drawer3Loading = false
          } else {
            this.totalcount5 = 0
            this.tableData5 = []
            this.drawer2Loading = false
          }
        }
      })
    },
    //服务中心里点击项目名称的详情
    getDtlItemList() {
      // if(this.drawer1==true){
      //   this.tableData3 = []
      // }else{
      //   this.tableData6 = []
      // }
      // console.log('getUserBaseCitydetail',this.toChildrenData.strsrvcent,this.toChildrenData.strdatetype,this.toChildrenData.strdate)
      xz.getUserBaseCitydetail(this.strsrvcent1, this.dataQuery.strdatetype, this.dataQuery.strdate, this.serDtlQuery).then(res => {
        console.log('getUserBaseCitydetail', res)
        if (res.msg && res.msg.length > 0) {
          if (this.drawer1 == true) {
            this.totalcount3 = parseInt(res.totalcount);
            this.tableData3 = res.msg
          } else {
            this.totalcount6 = parseInt(res.totalcount);
            this.tableData6 = res.msg
          }
        } else {
          if (this.drawer1 == true) {
            this.totalcount3 = 0
            this.tableData3 = []
          } else {
            this.totalcount6 = 0
            this.tableData6 = []
          }
        }
      })
    },
    //服务中心详情搜索
    onSearch() {
      this.getDtlList()
    },
    //市内市外详情搜索
    onSearch2() {
      this.getCityList()
    },
    handleClick(row) {
      console.log(row);
    },
    handleSizeChange(val) {
      this.page = val
      console.log(`每页 ${val} 条`);
    },
    async handdle(row, event, column, cell) {
      // console.log(row, event, column,cell)
      this.strsrvcent1 = row.StrSrvCent
      this.strsrvcent2 = row.StrSrvCent
      this.serDtlQuery.perpage = 10
      this.serDtlQuery.currpage = 1
      console.log(this.strsrvcent2)
      if (event.label == '服务中心') {
        this.isServiceAct = true
        //  if(row.data[Number(event.property)-1].Incityempuser<=0&&row.data[Number(event.property)-1].Outcityempuser<=0&&row.data[Number(event.property)-1].Otherempuser<=0){
        //     this.drawer1 = false
        //  }else{
        this.drawer1 = true
        this.getDtlList()
        //  }
        console.log('row', row)
      }
      if (event.property) {
        this.nowDateVal = row.data[Number(event.property) - 1].Strdate
      }
      if (event.label == '市内') {
        this.isServiceAct = false
        this.cityDtlQuery.perpage = 10
        this.cityDtlQuery.currpage = 1
        this.cityDtlQuery.strtype = '市内'
        this.cityTxt = '市内'
        if (row.data[Number(event.property) - 1].Incityempuser > 0) {
          this.drawer2 = true
          this.getCityList()
        } else {
          this.drawer2 = false
        }
      } else if (event.label == '市外') {
        this.isServiceAct = false
        this.cityDtlQuery.perpage = 10
        this.cityDtlQuery.currpage = 1
        this.cityDtlQuery.strtype = '市外'
        this.cityTxt = '市外'
        if (row.data[Number(event.property) - 1].Outcityempuser > 0) {
          this.drawer2 = true
          this.getCityList()
        } else {
          this.drawer2 = false
        }
      } else if (event.label == '其他情况') {
        this.isServiceAct = false
        this.cityDtlQuery.perpage = 10
        this.cityDtlQuery.currpage = 1
        this.cityDtlQuery.strtype = '其他'
        this.cityTxt = '其他情况'
        if (row.data[Number(event.property) - 1].Otherempuser > 0) {
          this.drawer2 = true
          this.getCityList()
        } else {
          this.drawer2 = false
        }
      }
    },
    async handdle2(row, event, column, cell) {
      this.strsrvcent2 = row.StrSrvCent
      this.cityDtlQuery.perpage = 10
      this.cityDtlQuery.currpage = 1
      this.isServiceAct = false
      console.log('handdle2', this.strsrvcent2)
      if (event.label == '市内') {
        this.cityDtlQuery.strtype = '市内'
        if (row.Incityempuser > 0) {
          this.drawer4 = true
          this.getCityList()
        } else {
          this.drawer4 = false
        }
        this.cityTxt = '市内'
      } else if (event.label == '市外') {
        this.cityDtlQuery.strtype = 'XXX'
        this.cityTxt = '市外'
        if (row.Outcityempuser > 0) {
          this.drawer4 = true
          this.getCityList()
        } else {
          this.drawer4 = false
        }
      } else if (event.label == '其他') {
        this.cityDtlQuery.strtype = ''
        this.cityTxt = '其他'
        if (row.Otherempuser > 0) {
          this.drawer4 = true
          this.getCityList()
        } else {
          this.drawer4 = false
        }
      }
    },
    async handdle3(row, event, column, cell) {
      this.strobjname2 = row.StrObjName
      // this.cityDtlQuery.strobjname = row.StrObjName
      this.cityDtlQuery.perpage = 10
      this.cityDtlQuery.currpage = 1
      this.isServiceAct = true
      if (event.label == '项目名称') {
        this.cityDtlQuery.strtype = 'all'
        this.drawer4 = true
        this.getCityList()
      }
      if (event.label == '市内') {
        this.cityDtlQuery.strtype = '市内'
        this.cityTxt = '市内'
        if (row.Incityempuser > 0) {
          this.drawer2 = true
          this.getCityList()
        } else {
          this.drawer2 = false
        }
      } else if (event.label == '市外') {
        this.cityDtlQuery.strtype = 'XXX'
        this.cityTxt = '市外'
        if (row.Outcityempuser > 0) {
          this.drawer2 = true
          this.getCityList()
        } else {
          this.drawer2 = false
        }
      } else if (event.label == '其他') {
        this.cityDtlQuery.strtype = ''
        this.cityTxt = '其他'
        if (row.Otherempuser > 0) {
          this.drawer2 = true
          this.getCityList()
        } else {
          this.drawer2 = false
        }
      }
    },
    //时间取值
    async getTimeSet() {
      const baseTime = this.dataQuery.dateVal
      const dateMoments = new Date(baseTime)
      const yearTime = parseTime(new Date(this.dataQuery.dateVal), '{y}')
      this.dataQuery.startdate = yearTime + '-01'
      this.dataQuery.enddate = yearTime + '-12'
      this.dataQuery.date = [yearTime + '-01', yearTime + '-02',
      yearTime + '-03', yearTime + '-04', yearTime + '-05',
      yearTime + '-06', yearTime + '-07', yearTime + '-08',
      yearTime + '-09', yearTime + '-10', yearTime + '-11', yearTime + '-12']
      // 处理日期超时
      if (new Date(this.dataQuery.startdate).getTime() > new Date().getTime()) {
        this.dataQuery.startdate = new Date().toLocaleDateString().split('/').join('-')
      }
      if (new Date(this.dataQuery.enddate).getTime() > new Date().getTime()) {
        this.dataQuery.enddate = new Date().toLocaleDateString().split('/').join('-')
      }
      // 格式化时间
      this.dataQuery.startdate = parseTime(new Date(this.dataQuery.startdate), '{y}-{m}')
      this.dataQuery.enddate = parseTime(new Date(this.dataQuery.enddate), '{y}-{m}')
      this.dataQuery.strdate = this.dataQuery.date.toString()
      console.log('时间strdate', this.dataQuery.strdate)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>

<style >
.annualChannelTable .el-table thead.is-group th {
  background-color: #fff;
}
.annualChannelTable .el-table td {
  padding: 0;
}
.annualChannelTable .el-table th {
  padding: 8px 0;
}
.monthDirection .el-button {
  padding: 0;
  height: 31px;
  width: 31px;
  border: none;
}
</style>